/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./minelucky.vue?vue&type=template&id=b6e2ada0&scoped=true"
import script from "./minelucky.vue?vue&type=script&lang=js"
export * from "./minelucky.vue?vue&type=script&lang=js"
import style0 from "./minelucky.vue?vue&type=style&index=0&id=b6e2ada0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e2ada0",
  null
  
)

export default component.exports